import React, { useMemo } from "react";
import "../Styles/MyAgent.css";

import { FaMapMarkerAlt, FaClock } from "react-icons/fa";

import { useNavigate } from "react-router-dom";
import { useMasterData } from "../context/MasterDataContext";
import LangIcon from "../assests/images/lang-icon.png";
import { getDefaultProfileIcon, RatingStars } from "../utils/commonFunctions";

function MyAgent({ agentData, languages, UserData }) {
  const navigate = useNavigate();
  const {
    religionMasterData,
    allCasteMasterData,
    communityMasterData,
    languageMasterData,
    allCountyMasterData,
  } = useMasterData();

  const religionOptions = useMemo(
    () =>
      religionMasterData?.map((item) => ({
        value: item.ReligionId,
        label: item.ReligionName,
      })) || [],
    [religionMasterData],
  );

  const casteOptions = useMemo(
    () =>
      allCasteMasterData?.map((item) => ({
        value: item.CasteL2Id,
        label: item.CasteName,
      })) || [],
    [allCasteMasterData],
  );

  const communityOptions = useMemo(
    () =>
      communityMasterData?.map((item) => ({
        value: item.CommunitiesId,
        label: item.CommunitiesName,
      })) || [],
    [communityMasterData],
  );

  const renderStars = (rating = 0) => {
    const numericRating = Number(rating);

    if (numericRating <= 0) return null;

    const fullStars = Math.round(numericRating);

    return (
      <>
        {"★".repeat(fullStars)}
        {"☆".repeat(5 - fullStars)}
      </>
    );
  };

  const servedLanguages = agentData?.LanguagesServe?.includes("all")
    ? "All Languages"
    : languages
        ?.filter((item) => agentData?.LanguagesServe?.includes(item.LangId))
        ?.slice(0, 3)
        ?.map((item) => item.LangDesc)
        ?.join(", ");

  if (!agentData) return null;

  return (
    <div className="my-agent-main-card">
      {/* TOP */}

      <div className="my-agent-top-section">
        {/* LEFT */}

        <div className="my-agent-profile-left">
          <img
            src={
              agentData?.User?.ProfilePhotoUrl ||
              getDefaultProfileIcon(agentData?.User)
            }
            alt=""
            className="my-agent-profile-image"
          />

          <div>
            <h3>{agentData?.User?.FirstName}</h3>

            <div className="my-agent-stars">
              {" "}
              <RatingStars rating={Number(agentData?.AverageRating)} />
            </div>

            <div className="my-agent-actions">
              <span>Remove Agent</span>

              <span
                onClick={() =>
                  navigate("/review-agent", {
                    state: {
                      agentData,
                      UserData,
                    },
                  })
                }
              >
                Review Agent ❯
              </span>
            </div>
          </div>
        </div>

        {/* RIGHT */}

        <div className="my-agent-contact-info">
          <p>Contact no : {agentData?.User?.PhoneNumber}</p>

          <p>Agent No {agentData?.AgentId}</p>
        </div>
      </div>

      <div className="hr-line"> </div>

      {/* BOTTOM */}

      <div className="my-agent-bottom-card">
        <div>
          <h4>{agentData?.BusinessName}</h4>

          <div className="my-agent-rating">
            {" "}
            <RatingStars rating={Number(agentData?.AverageRating)} />
             
          </div>

          <div className="my-agent-meta-row">
            <div>
              <FaMapMarkerAlt /> {agentData?.User?.Address?.CityId},{" "}
              {agentData?.User?.Address?.CountryId}
            </div>

            <div>
              <img className="icons-for-partner me-2" src={LangIcon} alt="" />
              {agentData?.LanguagesServe?.includes("all")
                ? " All Languages"
                : languages
                    ?.filter((item) =>
                      agentData?.LanguagesServe?.includes(item.LangId),
                    )
                    ?.slice(0, 3)
                    ?.map((item) => item.LangDesc)
                    ?.join(", ")}
            </div>

            <div>
              <FaClock /> {agentData?.BusinessExperience} years
            </div>
          </div>
        </div>

        <div
          className="my-agent-view-btn"
          onClick={() =>
            navigate("/agent-details", {
              state: {
                partner: agentData,
                religionOptions,
                casteOptions,
                communityOptions,
                languages,
                fromMyAgent: true,
              },
            })
          }
        >
          View Agency ❯
        </div>
      </div>
    </div>
  );
}

export default MyAgent;
